<template>
  <div class="promoCode">
    <div class="head_btn">优惠码</div>
    <div class="content">
      <div class="operation">
        <div>
          <el-button type="primary" plain size="medium" @click="newCode">新建优惠码</el-button>
          <el-button plain size="medium">删除</el-button>
          <el-dropdown size="medium">
            <el-button type="primary" size="medium">
              更多菜单
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in selectData" :key="index">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown size="medium">
            <el-button type="primary" size="medium">
              更多菜单
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in selectData" :key="index">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown size="medium">
            <el-button type="primary" size="medium">
              更多菜单
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item, index) in selectData" :key="index">{{item}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div style="width: 350px;display: flex;align-items: center">
          <div style="width:100px;font-size: 14px">优惠码名称</div>
          <el-input placeholder="请输入内容" :label="优惠码名称" v-model="input3" class="input-with-select">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>

      <div class="tables">
        <template>
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="优惠码名称" width="120">
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column>
            <el-table-column prop="name" label="适用商品" width="120"></el-table-column>
            <el-table-column prop="address" label="码类型" width="120"></el-table-column>
            <el-table-column prop="address" label="优惠类型" width="120"></el-table-column>
            <el-table-column prop="address" label="有效时间" width="220"></el-table-column>
            <el-table-column prop="address" label="状态" width="120"></el-table-column>
            <el-table-column prop="address" label="库存" width="120"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" size="small">编辑</el-button>
                <el-button type="text" size="small">删除</el-button>
                <el-button type="text" size="small">码率</el-button>
                <el-button type="text" size="small">统计</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      multipleSelection: [],
      input3: "",
      selectData: ["蚵仔煎", "双皮奶"],
      tableData: [
        {
          date: "2016-05-02",
          name: "买单",
          num: "1"
        },
        {
          date: "2016-05-04",
          name: "服务",
          num: "0"
        }
      ]
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    newCode() {
      this.$router.push("addShopLabel")
    }
  }
};
</script>

<style lang="scss" scoped>
.promoCode {
  padding: 0 10px;
  height: 100%;
  /*background: #f1f2f6;*/
  overflow: auto;
  border-left: 1px solid #f1f2f6;

  .head_btn {
    height: 50px;
    line-height: 50px;
    padding: 0 8px;
    font-size: 16px;
    background: rgba(255, 255, 255, 0.98);
  }

  .content {
    min-height: 300px;
    background: #f1f2f6;
    padding: 10px;

    .operation {
      padding: 8px;
      padding-left: 20px;
      background: #fff;
      border-radius: 5px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;

      .el-dropdown {
        margin-left: 10px;
      }
    }

    .tables {
      margin-top: 10px;
      padding-left: 13px;
      background: #fff;
    }
  }
}
</style>

<style lang="scss">
.promoCode {
  .el-button--primary {
    color: #000;
    background: #fff;
    border: 1px solid #cfcfcf;
  }
}
</style>